// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunks/browser/lite/" + chunkId + "." + {"49":"9b666ceed6bba492c792","587":"8fb9e11eac5a454c5a9f"}[chunkId] + ".js";
};